export default (chunks: string[]) => {
  const body = chunks.join('');
  const matches: any = body.matchAll(/src="(.*?\.pdf)"|href="(.*?\.pdf)"/gi);

  const pdfs = [...matches];

  if (!pdfs.length) {
    return [];
  }

  return pdfs.map((item: any) => item[2] ?? item[1]);
};
